














import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiService } from '@/services/ApiService';

@Component
export default class AmountSelector extends Vue {
  @Prop({ required: true })
  public amount: number;

  @Prop({ required: false, default: false })
  public enableZeroQuantity: boolean;

  @Prop({ required: false, default: 1.0 })
  public minSaleQuantity: number;

  @Prop({ required: false, default: false })
  public isLabelPrintAmount: boolean;

  private get lowerBound() {
    if (this.isLabelPrintAmount) {
      return 0;
    }
    return Math.max(Math.ceil(this.minSaleQuantity), 1);
  }

  private get upperBound() {
    return 9999;
  }

  public emitChange(amount) {
    this.$emit('change', amount);
  }

  get currentAmount() {
    return this.amount;
  }

  set currentAmount(value: number) {
    this.amountChanged(value);
  }

  public amountChanged(value) {
    let amount = value;

    if (value < (this.enableZeroQuantity ? 0 : 1)
      || isNaN(Number(value)) || value.toString() === '') {
      const errorMsg = this.$t('common.amountSelector.error.invalidAmount', { lowerBound: this.lowerBound });
      ApiService.defaultInfoHandler(errorMsg.toString());
      Vue.set(this.$refs.amountInput, 'value', this.currentAmount);
      return;
    } else if (value > 0 && value < this.minSaleQuantity) {
      amount = this.lowerBound;
    } else if (value > this.upperBound) {
      amount = this.upperBound;
    }

    this.emitChange(amount);
  }

  public decreaseAmount() {
    if (Number(this.amount) - 1 < this.lowerBound) {
      return;
    }
    this.emitChange(Number(this.amount) - 1);
  }

  public increaseAmount() {
    if (Number(this.amount) + 1 > this.upperBound) {
      return;
    }
    this.emitChange(Number(this.amount) + 1);
  }
}
